import React from 'react';
import FormField from './FormField';

/**
 * Multiline form field with sensible defaults for admin forms.
 */
const FormTextArea = React.forwardRef(function FormTextArea(
  { minRows = 2, ...props },
  ref
) {
  return (
    <FormField
      ref={ref}
      multiline
      minRows={minRows}
      {...props}
    />
  );
});

FormTextArea.displayName = 'FormTextArea';

export default FormTextArea;
